import createUseStyles from '@picsart/rc/create';
import { FontSizes, FontWeights } from '@picsart/rc/fonts';

const useMobileMenuStyles = createUseStyles(
  {
    root: {},
    navListItem: {
      fontSize: FontSizes.Size_4,
      color: 'var(--texts-negative)',
      display: 'block',
    },
    navLink: {
      color: 'var(--texts-negative)',
      fontSize: FontSizes.Size_4,
      lineHeight: '17px',
      fontWeight: FontWeights.SemiBold,
      letterSpacing: '0.96px',
      textTransform: 'uppercase',
      padding: '14px 50px 14px 0',
      display: 'block',
      transition: 'color 0.3s, background 0.3s',
      borderBottom: '1px solid var(--statuses-positive-base-action)',
      textAlign: 'left',

      '&:hover': {
        backgroundColor: 'var(--backgrounds-tint-2)',
      },
    },
  },
  { name: 'mobile-menu' },
);

export default useMobileMenuStyles;
